import React, { createContext, useState, useEffect, useContext } from "react";
import axios from "axios";
import { AuthContext } from "./AuthContext";

const server_url = process.env.REACT_APP_BACKEND_URL;

interface User {
  id: number;
  name: string | null;
  mail: string;
  uuid: string;
  created_at: string;
  role: string;
  phone: string | null;
  member_of: number | null;
}

interface UserContextType {
  user: User | null;
  setUser: React.Dispatch<React.SetStateAction<User | null>>;
  fetchUserData: () => Promise<void>;
  updateUserData: (updatedFields: {
    name?: string;
    phone?: string;
  }) => Promise<void>;
  isLoading: boolean;
}

export const UserContext = createContext<UserContextType>({
  user: null,
  setUser: () => {},
  fetchUserData: async () => {},
  updateUserData: async () => {},
  isLoading: false,
});

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { session } = useContext(AuthContext);

  const fetchUserData = async () => {
    if (session) {
      setIsLoading(true);
      try {
        const response = await axios.post(
          `${server_url}/getUserByToken`,
          {
            access_token: session.access_token,
          }
        );
        if (response.data.status) {
          setUser(response.data.data);
        } else {
          // TODO: Fehlerbehandlung
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        // TODO: Fehlerbehandlung
      } finally {
        setIsLoading(false);
      }
    } else {
      setUser(null);
      setIsLoading(false);
    }
  };

  const updateUserData = async (updatedFields: {
    name?: string;
    phone?: string;
  }) => {
    if (session) {
      setIsLoading(true);
      try {
        const response = await axios.post(
          `${server_url}/updateUserByToken`,
          {
            access_token: session.access_token,
            ...updatedFields,
          }
        );
        if (response.data.status) {
          setUser(response.data.data);
        } else {
          // TODO: error
        }
      } catch (error) {
        console.error("Error updating user data:", error);
        // TODO: error
      } finally {
        setIsLoading(false);
      }
    } else {
      // TODO: Behandel wenn keine Session verfügbar
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [session]);

  return (
    <UserContext.Provider
      value={{ user, setUser, fetchUserData, updateUserData, isLoading }}
    >
      {children}
    </UserContext.Provider>
  );
};
